var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1949_708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.7188C18.4721 23.7188 23.7188 18.4721 23.7188 12C23.7188 5.52791 18.4721 0.28125 12 0.28125C5.52791 0.28125 0.28125 5.52791 0.28125 12C0.28125 18.4721 5.52791 23.7188 12 23.7188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M22.6734 16.8455C22.7022 16.7295 22.7503 16.6191 22.8157 16.519C23.414 15.0876 23.7211 13.5514 23.7193 12C23.7193 11.9161 23.7179 11.8327 23.7161 11.7492L16.126 4.15917C15.4014 4.0823 14.6732 4.04507 13.9445 4.04766C11.7857 4.04766 10.3083 5.36484 10.3083 7.78495V9.87188H7.875V12.7078L10.3083 15.1406V19.9523L13.9177 23.5617C15.816 23.2461 17.6075 22.4683 19.1344 21.2971C20.6613 20.1259 21.8766 18.5971 22.6734 16.8455Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2354 19.9523V12.7078H15.6776L16.0435 9.87187H13.2354V8.06583C13.2354 7.24669 13.4628 6.68855 14.6374 6.68855H16.126V4.15912C15.4014 4.0823 14.6731 4.04509 13.9445 4.04766C11.7857 4.04766 10.3082 5.36484 10.3082 7.78495V9.87187H7.875V12.7078H10.3083V19.9523H13.2354Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1949_708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/facebook 1.fcf384246b320151681dc668cf4051fc.svg";
export { ForwardRef as ReactComponent };